import { createApp, watch } from 'vue';
import App from './App.vue';
import router from './router/router.js';
import store from './store/store.js';
//import axios from 'axios';
import axios from '@/js/axiosConfig'; //헤더정보에 Language 설정을 위해 변경
// 해외법인 작업 수정(다국어 처리)
import i18n from './js/i18n';

import { componentPermission } from '@/js/permission';
import 'reset-css';
import './assets/css/app.css';
import './assets/css/reset.css';
import './assets/css/common.css';
import './assets/css/font/font.css';

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

// Quasar
import { Quasar } from 'quasar';


const app = createApp(App);

app.use(router).use(store).use(Quasar).use(i18n).use(Toast, 
{
    position: 'bottom-center',
    toastDefaults: {
        default: {
            style: {
                fontSize: '4px',
            }
        },
    }
}).use(VCalendar, 
{
    locales: {
      'ko-KR': {
        firstDayOfWeek: 0, // 주의 시작 요일 설정 (0: 일요일)
        masks: {
            L: 'YYYY-MM-DD',
            title: 'MMMM YYYY',
            weekdays: 'W' 
          // 더 많은 마스크 포맷을 여기에 추가할 수 있습니다.
        }
      },
      'en-US': {
        firstDayOfWeek: 0, // 주의 시작 요일 설정 (0: 일요일)
        masks: {
            L: 'YYYY-MM-DD',
            title: 'MMMM YYYY',
            weekdays: 'WWW' 
          // 더 많은 마스크 포맷을 여기에 추가할 수 있습니다.
        }
      }
    },
    locale: 'ko-KR' // 기본 로케일 설정
});

const refreshFire = async () => {
    store.dispatch('clearVehicleData');
    store.dispatch('IotResult/clearResult');
    store.dispatch('clearDataItems');
    store.dispatch('setGroupId', null);
    store.dispatch('setLoginGroup', null);
    store.commit('setCurrentPage', 1);
    store.dispatch('setVinId', '');
    store.dispatch('setActiveMenu', null);
    store.dispatch('resetAllParams');
    store.dispatch('setIotState',null);
    store.dispatch('setAxiosLoading', false);
    store.dispatch('regiSave/clearRegiTemp');
    store.dispatch('clearPermission');
    await router.push({ name: 'login' });
    window.location.reload();
};

//const autoLoginData = (localStorage.getItem('autoLogin') ==="true") || false; //autoLogin 주석처리

const refresh = async () => {
    const token = store.getters['loginModule/getRefreshToken'];
    if (token) {
    //if (token && autoLoginData) { //autoLogin 주석처리
        // let params = {
        //     autoLogin: autoLoginData || false
        // }
        
            //await axios.get(`${process.env.VUE_APP_API_URL_AUTH}/api/auth/refreshToken`, { params }).then( async (response) => {  //autoLogin 주석처리
            await axios.get(`${process.env.VUE_APP_API_URL_AUTH}/api/auth/refreshToken`).then( async (response) => {
                const responseData = response.data;
                if (responseData.error) {
                    await refreshFire();
                    return false;
                } else if (responseData.success === true) {
                    const loginData = {
                        accessToken: responseData.data.accessToken,
                        refreshToken: responseData.data.refreshToken
                    };
                    await store.dispatch('loginModule/saveLoginData', loginData);

                    const loginId = store.state.loginModule.id;
                    await axios.get(`${process.env.VUE_APP_API_URL_API}/api/tms/member/detail/${loginId}`).then( async (response) => {
                        const responseData = response.data;
                        if (responseData.error) {
                            await refreshFire(responseData);
                        } else if (responseData.success === true) {
                            const name = responseData.data[0].name;
                            const group = responseData.data[0].groupId;
                            store.dispatch('loginModule/setName', name);
                            store.dispatch('setLoginGroup', group);
                            const groupIdToMatch = store.state.loginGroup;
                            await store.dispatch('setGroupId', groupIdToMatch);
                            await componentPermission();

                            window.location.reload();
                        }
                    }).catch(async (error) => {
                        await refreshFire();
                    });
                }
            }).catch( async (error) => {
                await refreshFire();
            });

    } else {
        await refreshFire();
    }
};

    app.config.globalProperties.$axios = axios;

    axios.interceptors.request.use( // 요청
        async (config) => {
            const token = store.getters['loginModule/getAccessToken'];
            const reToken = store.getters['loginModule/getRefreshToken'];
            //if (config.url === "https://iz8hmpwfrb.execute-api.ap-northeast-2.amazonaws.com/prod-trip-api/trip") {
            if (config.url === `${process.env.VUE_APP_API_OPERATIONDATA_CUSDETAIL_URL}`) {
                return config;
            }
            if (token) {
                if (config.url === `${process.env.VUE_APP_API_URL_API}/api/daedong/v1.0/customer/report`) {
                    // config.headers['X-AUTH-ACCESS-TOKEN'] = appToken;
                } else {
                    config.headers['X-AUTH-ACCESS-TOKEN'] = token;
                    config.headers['X-AUTH-REFRESH-TOKEN'] = reToken;
                }
            }
            store.dispatch('IotResult/clearErrorMsg');
            store.dispatch('IotResult/clearDefHeaterTest');
            store.dispatch('IotResult/clearDefControlTest');
            store.dispatch('IotResult/clearDefInjectTest');
            store.dispatch('IotResult/clearLeakTest');
            store.dispatch('IotResult/clearPrvTest');
            store.dispatch('clearTesting');

            return config;
        },
         async (error) => {
            if (error.response.data.error) {
                if (error.response.data.error.errorCode === 'E0802') {
                    await refresh();
                } else if (error.response.data.error.errorCode === 'E0803') {
                    await refreshFire();
                }
            }
            return error;
        }
    );

    axios.interceptors.response.use( async function (response) {
        if (response.data.error) {
            if (response.data.error.errorCode === 'E0802') {
                await refresh();
            } else if (response.data.error.errorCode === 'E0803') {
                const loginData = {
                    accessToken: null,
                    refreshToken: null
                };
                store.dispatch('loginModule/saveLoginData', loginData);
                await refreshFire();
            } else if (response.data.error.errorCode === 'E0105') {
                const loginData = {
                    accessToken: null,
                    refreshToken: null
                };
                store.dispatch('loginModule/saveLoginData', loginData);
                await refreshFire();
            }
        } else {
            const token = store.getters['loginModule/getAccessToken'];
            if(response.headers['x-auth-access-token']) {
                const loginData = {
                    accessToken: response.headers['x-auth-access-token'],
                    refreshToken: null
                };
                store.dispatch('loginModule/saveLoginData', loginData);
            }
        }
        return response;
        }, async function (error) {
            if (error.code == 'ERR_NETWORK') {
                return Promise.reject(error);
            }
            if (error.response.data.error) {
                if (error.response.data.error.errorCode === 'E0802') {
                    await refresh();
                } else if (error.response.data.error.errorCode === 'E0803') {
                    const loginData = {
                        accessToken: null,
                        refreshToken: null
                    };
                    store.dispatch('loginModule/saveLoginData', loginData);
                    await refreshFire();
                } else if (error.response.data.error.errorCode === 'E0105') {
                    const loginData = {
                        accessToken: null,
                        refreshToken: null
                    };
                    store.dispatch('loginModule/saveLoginData', loginData);
                    await refreshFire();
                }
            }
            return Promise.reject(error);
        }
    );

    // =========== 등록화면에서 데이터 임시저장해놓은거 닫으면 지우는 부분
    const storeDataItems = store.getters.getDataItems;

    const pageActionMap = {
        modelRegi: 'clearModelRegi',
        faqRegi: 'clearFaqRegi',
        noticeRegi: 'clearNoticeRegi',
        postRegi: 'clearPostRegi',
        categoryRegi: 'clearCategory',
        shopBannerRegi: 'clearBanner',
        partDisplayRegi: 'clearParts',
        customerRegi: 'clearUserRegi',
        gptBannerRegi: 'clearGptBannerRegi'
    };

    watch(storeDataItems, (newVal, oldVal) => {
        const pageRegiStatus = {};

        Object.keys(pageActionMap).forEach(page => {
            pageRegiStatus[page] = false;
        });

        storeDataItems.forEach(item => {
        if (pageRegiStatus.hasOwnProperty(item.page)) {
            pageRegiStatus[item.page] = true;
        }
        });

        Object.entries(pageRegiStatus).forEach(([page, isRegistered]) => {
        if (!isRegistered) {
            const action = pageActionMap[page];
            if (action) {
            store.dispatch(`regiSave/${action}`);
            }
        }
        });
    }
    );
    function injectApiParams(accessToken, vinId){
        router.push({ name: 'reportDetailAppMng', params: { accessToken, vinId } })
    };

app.mount('#app');